const onHandlerScrollToTop = () => {
	if (typeof window !== 'undefined') {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}
};

const windowUtils = {
	onHandlerScrollToTop
};

export default windowUtils;
